import { BaseService } from '../../../infra/base.service'
import { FormDataLinksRepository } from './form-data-links.repository'
import type { FormDataLink } from './form-data-link'

export class FormDataLinksService extends BaseService<FormDataLink> {
    constructor(private rep: FormDataLinksRepository) {
        super(rep)
    }
}
